<template>
  <div>
    <el-row :gutter="30">
      <el-col :sm="10">
        <div class="product__image">
          <img v-if="mainImage && mainImage.url" :src="mainImage.url"/>
          <img v-else :src="fallbackJpg">
        </div>
      </el-col>
      <el-col :sm="14">
        <h2 v-if="tagLine">{{ tagLine }}</h2>
        <div v-html="text"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import fallbackJpg from '@/assets/images/fallbackVertical.jpg';

  export default {
    name: 'ProductOverview',
    data() {
      return {
        fallbackJpg
      }
    },
    props: {
      mainImage: {
        type: Object
      },
      tagLine: {
        type: String
      },
      text: {
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .product__image {
    margin-bottom: 16px;

    @include res(sm) {
      margin-bottom: 0;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
</style>
